module.exports = __webpack_public_path__ + "img/filter_icon.98d38499.svg";